export default {
  underline: {
    position: `relative`,
    '.tabs_tabList': {
      display: `flex`,
      maxWidth: 'calc(100vw - 32px)',
      overflowX: 'auto',
      gap: '11',
      m: 0,
      p: 0,
    },
    '.tabs_tabList::-webkit-scrollbar': {
      width: '2px',
    },
    '.tabs_tabList::-webkit-scrollbar-track ': {
      backgroundColor: 'transparent',
    },
    '.tabs_tabList::-webkit-scrollbar-thumb ': {
      backgroundColor: 'gray300',
      width: '1px',
      borderRadius: '20px',
      border: '7px solid transparent',
      backgroundClip: 'content-box',
    },
    '.tabs_tab': {
      variant: `text.h6`,
      fontWeight: `medium`,
      cursor: `pointer`,
      outline: `none`,
      pb: '4px',
      m: 0,
      whiteSpace: 'nowrap',
      ':not(.tabs_selectedTab):hover': {
        color: `omegaDarker`,
        borderBottomColor: `omegaDarker`,
      },
    },
    '.tabs_selectedTab': {
      borderBottomColor: `primary700`,
      borderBottomWidth: `3px`,
      borderBottomStyle: `solid`,
    },
    '.react-tabs__tab-panel:not([class$="--selected"])': {
      display: `none`,
    },
  },
  pill: {
    position: `relative`,
    '.tabs_tabList': {
      display: `flex`,
      justifyContent: `center`,
      width: 'fit-content',
      mx: 'auto',
      my: 0,
      p: 0,
      backgroundColor: 'white',
      border: '1px',
      borderColor: 'gray700',
      borderStyle: 'solid',
      borderRadius: '56px',
    },
    '.tabs_tab': {
      display: `flex`,
      alignItems: `center`,
      justifyContent: `center`,
      listStyle: `none`,
      cursor: `pointer`,
      transition: `all 400ms ease`,
      bg: `white`,
      color: `gray700`,
      outline: `none`,
      px: 4,
      py: 3,
      m: 0,
      borderRadius: '56px',
    },
    '.tabs_tab + .tabs_tab': {
      ml: `1px`,
    },
    '.tabs_selectedTab': {
      bg: `gray700`,
      color: `white`,
    },
  },
  dots: {
    position: `relative`,
    '.tabs_tabList': {
      display: `flex`,
      justifyContent: `center`,
      m: 0,
      p: 0,
    },
    '.tabs_tab': {
      listStyle: `none`,
      size: `14px`,
      textIndent: `-9999px`,
      bg: `omega`,
      borderRadius: `full`,
      cursor: `pointer`,
      mx: 1,
      ':not(.tabs_selectedTab):hover': {
        bg: `omegaDarker`,
      },
    },
    '.tabs_selectedTab': {
      bg: `alpha`,
    },
  },
  'dots-new': {
    position: `relative`,
    '.tabs_tabList': {
      display: `flex`,
      justifyContent: `center`,
      m: 0,
      p: 0,
    },
    '.tabs_tab': {
      listStyle: `none`,
      size: `12px`,
      textIndent: `-9999px`,
      bg: `#E0F2FE`,
      borderRadius: `full`,
      cursor: `pointer`,
      mx: 1,
      ':not(.tabs_selectedTab):hover': {
        bg: `#004F7A`,
      },
    },
    '.tabs_selectedTab': {
      bg: `#026AA2`,
    },
  },
  pages: {
    mx: '20px',
  },
  arrowWrapper: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    top: ['auto', null, null, -95],
    bottom: [-75, null, null, 'auto'],
    right: 0,
    left: [0, null, null, 'auto'],
    width: '180px',
    mx: 'auto',
  },
  arrowButton: {
    cursor: 'pointer',
    zIndex: 10,
    maxWidth: `44px`,
    maxHeight: `44px`,
    borderWidth: `sm`,
    p: '12px',
    borderRadius: '8px',
    border: '1px solid #D0D5DD',
    borderColor: 'gray300',
    background: 'white',
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  },
  gradientArrowButtonContainer: {
    width: '44px',
    height: '44px',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'linear-gradient(#50c4f8, #0086c9)',
    cursor: 'pointer',
    transition: 'all ease 250ms',
    '&:hover': {
      background: '#026AA2',
      '& > div': {
        background: '#026AA2',
        '& path': {
          stroke: '#fff',
        },
      },
    },
  },
  gradientArrowButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '42px',
    height: '42px',
    borderRadius: '50%',
    background: '#fff',
    transition: 'all ease 250ms',
  },
  dotsNewArrowContainer: {
    alignItems: 'center',
  },
  leftArrow: {
    paddingRight: '2px',
  },
  rightArrow: {
    paddingRight: '2px',
    rotate: '180deg',
  },
};
